/** The active theme(s). Today one row per user; the table supports N for future
 *  saved themes. JSON-shaped fields (role/entity/palette overrides) are stored as
 *  TEXT so the in-memory adapter never has to understand them. */
export const themesTable = `
CREATE TABLE IF NOT EXISTS themes (
  id                TEXT PRIMARY KEY,
  preset            TEXT NOT NULL,
  variant           TEXT NOT NULL,
  source            TEXT NOT NULL,
  source_dark       TEXT,
  role_overrides    TEXT NOT NULL DEFAULT '{"light":{},"dark":{}}',
  entity_palette    TEXT NOT NULL DEFAULT '[]',
  palette_overrides TEXT NOT NULL DEFAULT '{}',
  entity_overrides  TEXT NOT NULL DEFAULT '{}',
  block_tint_diff   REAL NOT NULL DEFAULT 0.22,
  block_gradient    INTEGER NOT NULL DEFAULT 1,
  chroma_boost      REAL NOT NULL DEFAULT 0,
  auto_color_calendars INTEGER NOT NULL DEFAULT 1,
  created_at        TEXT NOT NULL,
  updated_at        TEXT NOT NULL,
  deleted_at        TEXT
);
`.trim();

/** ALTER statements to bring an existing `themes` table up to the current
 *  schema. Each is wrapped in try/catch by migrate(). Mirrors `calendarsAlters`. */
export const themesAlters = [
  "ALTER TABLE themes ADD COLUMN chroma_boost REAL NOT NULL DEFAULT 0;",
  "ALTER TABLE themes ADD COLUMN auto_color_calendars INTEGER NOT NULL DEFAULT 1;",
];
